export default function Section({ children }: { children: any }) {
  return (
    <div className="pb-8 mb-4 border-b border-rsc-light-blue/10 last:border-b-0 last:mb-0">
      {children}
    </div>
  );
}
